export default __webpack_public_path__ + "static/media/DB_1.4764fe5c.png";